import type { ReactNode } from "react";
import { useEffect, useState } from "react";

interface ClientOnlyProps {
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * A component that renders its children only on the client-side, after hydration is complete.
 * This is crucial for components that rely on browser-specific APIs or cause hydration mismatches.
 * @param children The component/elements to render only on the client.
 * @param fallback An optional element to render on the server and during initial client render (e.g., a loading spinner or placeholder).
 */
export default function ClientOnly({
  children,
  fallback = null,
}: ClientOnlyProps) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient ? children : fallback;
}
